import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';
import { API_PDP_DELETE } from 'constants/api';
import { generateURL } from 'helpers';

export const deletePDP = createAsyncThunk<void, { id: number }>(
  'pdp/deletePDP',
  async ({ id }, { rejectWithValue }) =>
    api.axios
      .delete(generateURL(API_PDP_DELETE, { id }))
      .then(() => undefined)
      .catch((e) => rejectWithValue(e.response?.data)),
);
